import { render } from "./LeftSectors.vue?vue&type=template&id=288a8459&scoped=true"
import script from "./LeftSectors.vue?vue&type=script&lang=js"
export * from "./LeftSectors.vue?vue&type=script&lang=js"

import "./LeftSectors.vue?vue&type=style&index=0&id=288a8459&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/NfzNB5gn/0/softbot/chatbot/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-288a8459"]])

export default __exports__
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QScrollArea,QAvatar,QBtn,QIcon,QInput,QSeparator});
